import React from 'react';
import PropTypes from 'prop-types';
import { List, Node } from './SequentialNodeLoader.styles';

export const SequentialNodeLoader = ({ nodes, delay = 1, speed = 0.5 }) => {
  return (
    <List>
      {nodes.map((node, i) => (
        <Node length={nodes.length} delay={delay} speed={speed} key={i}>
          {node}
        </Node>
      ))}
    </List>
  );
};
SequentialNodeLoader.displayName = 'SequentialNodeLoader';
SequentialNodeLoader.propTypes = {
  nodes: PropTypes.arrayOf(PropTypes.node).isRequired,
  speed: PropTypes.number,
  delay: PropTypes.number,
};
